export default __webpack_public_path__ + "static/media/Datenschutzbestimmungen.72ae9fe2.pdf";